import { AlertTriangle, CheckCircle, ClipboardList, Clock } from "lucide-react";

import { Card, CardContent } from "../../../components/ui/card.jsx";

const TaskStats = ({ statusCounts, onFilterClick }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 w-full">
      <Card
        className="bg-yale-blue-50 border-slate-200 dark:bg-yale-blue-900/40 dark:border-yale-blue-800 cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
        onClick={() => onFilterClick("ALL")}
      >
        <CardContent className="p-3 md:p-5">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[10px] md:text-xs font-bold text-yale-blue-500 uppercase tracking-widest">Total Tasks</p>
              <p className="text-xl md:text-3xl font-black text-yale-blue-900 dark:text-white mt-1">{statusCounts.ALL}</p>
            </div>
            <div className="p-2 bg-slate-100 dark:bg-yale-blue-800 rounded-lg group-hover:bg-slate-200 dark:group-hover:bg-yale-blue-700 transition-colors">
              <ClipboardList className="h-4 md:h-6 w-4 md:w-6 text-slate-600 dark:text-slate-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card
        className="bg-yale-blue-50 border-amber-100 dark:bg-amber-900/10 dark:border-amber-900/20 cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
        onClick={() => onFilterClick("PENDING")}
      >
        <CardContent className="p-3 md:p-5">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[10px] md:text-xs font-bold text-yale-blue-600 dark:text-yale-blue-400 uppercase tracking-widest">
                Pending
              </p>
              <p className="text-xl md:text-3xl font-black text-yale-blue-700 dark:text-amber-300 mt-1">{statusCounts.PENDING}</p>
            </div>
            <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg group-hover:bg-amber-200 dark:group-hover:bg-amber-800 transition-colors">
              <Clock className="h-4 md:h-6 w-4 md:w-6 text-yale-blue-600 dark:text-yale-blue-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card
        className="bg-emerald-50 border-emerald-100 dark:bg-emerald-900/10 dark:border-emerald-900/20 cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
        onClick={() => onFilterClick("COMPLETED")}
      >
        <CardContent className="p-3 md:p-5">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[10px] md:text-xs font-bold text-emerald-600 dark:text-emerald-400 uppercase tracking-widest">
                Done
              </p>
              <p className="text-xl md:text-3xl font-black text-emerald-700 dark:text-emerald-300 mt-1">
                {statusCounts.COMPLETED}
              </p>
            </div>
            <div className="p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg group-hover:bg-emerald-200 dark:group-hover:bg-emerald-800 transition-colors">
              <CheckCircle className="h-4 md:h-6 w-4 md:w-6 text-emerald-600 dark:text-emerald-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card
        className="bg-rose-50 border-rose-100 dark:bg-rose-900/10 dark:border-rose-900/20 cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
        onClick={() => onFilterClick("OVERDUE")}
      >
        <CardContent className="p-3 md:p-5">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[10px] md:text-xs font-bold text-rose-600 dark:text-rose-400 uppercase tracking-widest">
                Overdue
              </p>
              <p className="text-xl md:text-3xl font-black text-rose-700 dark:text-rose-300 mt-1">{statusCounts.OVERDUE}</p>
            </div>
            <div className="p-2 bg-rose-100 dark:bg-rose-900/30 rounded-lg group-hover:bg-rose-200 dark:group-hover:bg-rose-800 transition-colors">
              <AlertTriangle className="h-4 md:h-6 w-4 md:w-6 text-rose-600 dark:text-rose-400" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TaskStats;
